import { useAppSelector } from 'shared';

export const useSweetShopArticlePageState = () => (
    useAppSelector((store) => store.sweetShopArticlePage)
);
